<div (mouseenter)="tooltip.onHover()" (mouseleave)="tooltip.onExit(); tooltip.rightClickPresses = 0;" *ngIf="tooltip.type === 'customer' && tooltip.dto" [style]="positionStyle"
     id="container">
  <div (contextmenu)="$event.preventDefault(); onRightClick($event)" id="content">
    <div id="header">{{tooltip.dto.companyName}}</div>
    <div id="second-header">{{tooltip.dto.contactName}}</div>
    <div [style]="color" id="circle" class="circle">{{tooltip.dto.companyName.substr(0, 1)}}</div>
    <div id="info">
      <div class="icon" style="grid-area: i1">
        <i class="fas fa-phone"></i>
      </div>
      <div class="data" style="grid-area: d1">{{tooltip.dto.phoneNumber}}</div>

      <div class="icon" style="grid-area: i2">
        <i class="fas fa-at"></i>
      </div>
      <div class="data" style="grid-area: d2">{{tooltip.dto.email}}</div>

      <div class="icon" style="grid-area: i3">
        <i class="fas fa-home"></i>
      </div>
      <div class="data" style="grid-area: d3">{{tooltip.dto.address1}}, {{tooltip.dto.address2}}
        , {{tooltip.dto.city}}, {{tooltip.dto.state}}, {{tooltip.dto.zip}}</div>

      <div class="icon" style="grid-area: i4">
        <i class="fas fa-file-alt"></i>
      </div>
      <div class="data" style="grid-area: d4; overflow-x: hidden; overflow-y: auto">
        <p *ngFor="let str of tooltip.dto.notes.split('\n')">
          {{str}}
        </p>
      </div>

      <div class="actions">
        <button (click)="navigate()" pRipple><i class="fas fa-link"></i> Navigate</button>
      </div>
    </div>
  </div>
</div>
